import ServiceBase from "../../../servicebase";
import { PaginatedResponse, Response } from "../../../../model";
import { AltaClientesAnual, AltaClientesIndicador, AltaClientesMes, ComparativaReporte, EmailsEnviadosOut, InformeOperacionesOut, ReporteOperacionesOut } from "../../../../model/reportes";
import { Estados } from "../../../operaciones/model/Estados";
import { ReporteEmisionesOut } from "../../../../model/reportes/ReporteEmisionesOut";
import { ReporteEmisionesQuery } from "../../../../model/reportes/ReporteEmisionesQuery";

export class ReportesService extends ServiceBase {

  AltaClientes = {
    indicadores: (data?: { desde?: number, hasta?: number, tipo?: number, idUsuario?: number }) => 
      this.GetFetch<Response<AltaClientesIndicador[]>>("Reportes/AltaClientes/indicadores", data),

    anual: (data?: { desde?: number, hasta?: number, tipo?: number, idUsuario?: number, indicador?: number, comparar?: string }) => 
      this.GetFetch<Response<AltaClientesAnual>>("Reportes/AltaClientes/anual", data),

    mes: (data?: { periodo?: number, tipo?: number, idUsuario?: number, indicador?: number, comparar?: string }) => 
      this.GetFetch<Response<AltaClientesMes>>("Reportes/AltaClientes/mes", data),

  }

  Comparativa = {
    reporte: (data:{ pageIndex?: number, pageSize?: number, sort?: string, creafechaDesde:string, creafechaHasta: string, tipo?: string, email?:string, cotiNombre?: string, cotiFechaDesde?:string, cotiFechaHasta?:string, cotiEmail?: string, cotiWhatsapp?: string }) => 
      this.GetFetch<PaginatedResponse<ComparativaReporte>>('Reportes/Comparativa/reporte', data)
  }
  
  EmailsEnviados = {
    reporte: (data:{ pageIndex?: number, pageSize?: number, sort?: string, creafechaDesde:string, creafechaHasta: string, tipos?: string, operacionNumero?: string, remitenteCorreo?: string, destinatarioCorreo?: string }) => 
      this.GetFetch<PaginatedResponse<EmailsEnviadosOut>>('Reportes/EmailsEnviados/reporte', data)
  }

  InformeOperaciones = {
    reporte: (data: { indice: string; formula: string; fecha?: Date[]; estados?: number[]; tipoCanal?: string; origenMarca?: string; canalVentas?: string; idcliente?: number; idejecutivo?: number; proveedor?: string; producto?: string }) => 
      this.PostFetch<PaginatedResponse<InformeOperacionesOut>>('Reportes/InformeOperaciones/reporte', data)
  }
  
  ReporteOperaciones = {
    reporte: (data: { paging: { pageIndex?: number; pageSize?: number; sort?: string; },
      estado?: Estados; creaFecha?: Date[]; codigo?: number; idEjecutivo?: number;
      idMedioPago?: number; idSociedad?: number; idCliente?: number; idCotizador?: number; idProveedor?: number; idOrigen?: number; idDestino?: number;
      fechaPago?: Date[]; fechaVoucher?: Date[]; facturaNro?: string; fechaFactura?: Date[]; facturaPrestador?: string; }) => 
      this.PostFetch<PaginatedResponse<ReporteOperacionesOut>>('Reportes/ReporteOperaciones/reporte', data)
  }
  
  Emisiones = {
    reporte: (data: ReporteEmisionesQuery) => 
      this.PostFetch<PaginatedResponse<ReporteEmisionesOut>>('Reportes/Emisiones/reporte', data)
  }
  
}
